import bem from '../../../utils/bem';

const Tag = (props) => {
  const { href, modifiers, extra, target, label, id } = props;
  const componentClassName = bem('tag', modifiers, '', extra);

  if (href) {
    return (
      <a
        href={href}
        target={target || '_self'}
        className={componentClassName}
        id={id}
      >
        {label}
      </a>
    );
  }

  return (
    <span className={componentClassName} id={id}>
      {label}
    </span>
  );
};

export default Tag;
